import { connect } from "react-redux";

import GlobalChangeMapChart from "../../components/visualizations/global_change_map_chart";
import { countryChanged } from "../../actions/filters";

const mapStateToProps = (state) => {
  if (!(state.main.loading.loadedData.mainChart)) { return {}; }

  const dataAndOptions = state.main.loading.loadedData.mainChart;
  const title = `MAP OF SURVEYED COUNTRIES SHOWING PERCENTAGE CHANGE IN COMBINED TARIFF (${state.main.loading.loadedData.previousYear}-${state.main.loading.loadedData.currentYear})`;
  const selectedCountry = state.main.filters.country.selectedValue;

  return { dataAndOptions, title, selectedCountry };
};

const mapDispatchToProps = dispatch => ({
  onChange: (e) => { dispatch(countryChanged({ value: e, label: e })); }
});

export default connect(mapStateToProps, mapDispatchToProps)(GlobalChangeMapChart);
